import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useCallback, useMemo, useEffect } from 'react';
import { Multiplier } from 'hoi-poi-ui';
import { useWeb5Context } from "../../../../../lib/Web5Context";
const AddForm = _ref => {
  let {
    form,
    onChange,
    onBlur,
    schema = [],
    modalInputRef,
    className,
    orientation = 'horizontal'
  } = _ref;
  const {
    t
  } = useWeb5Context();
  const {
    values,
    errors,
    touched
  } = form;
  useEffect(() => {
    var _modalInputRef$curren;
    modalInputRef === null || modalInputRef === void 0 ? void 0 : (_modalInputRef$curren = modalInputRef.current) === null || _modalInputRef$curren === void 0 ? void 0 : _modalInputRef$curren.focus();
  }, [modalInputRef]);
  const handleOnChange = useCallback((value, newValue, index, schema, field, action) => {
    onChange && onChange({
      value,
      newValue,
      index,
      field,
      action
    });
    setTimeout(() => {
      var _modalInputRef$curren2;
      if (action === 'add') modalInputRef === null || modalInputRef === void 0 ? void 0 : (_modalInputRef$curren2 = modalInputRef.current) === null || _modalInputRef$curren2 === void 0 ? void 0 : _modalInputRef$curren2.focus();
    }, 50);
  }, [modalInputRef, onChange]);
  const handleOnBlur = useCallback((value, newValue, index, schema, field) => {
    onBlur && onBlur({
      value,
      newValue,
      index,
      field
    });
  }, [onBlur]);
  const getErrors = useMemo(() => {
    const newErrors = errors.reduce((arr, error, index) => {
      const newObj = Object.entries(error).reduce((obj, _ref2) => {
        let [key, value] = _ref2;
        return _objectSpread(_objectSpread({}, obj), {}, {
          [key]: touched[index] && touched[index][key] ? value : false
        });
      }, {});
      return [...arr, newObj];
    }, []);
    return newErrors;
  }, [errors, touched]);
  const multiplierProps = useMemo(() => ({
    className,
    orientation,
    labelMode: 'vertical',
    separator: true,
    buttonLabel: t('label_add_more'),
    value: values,
    error: getErrors,
    schema: [{
      fields: schema
    }],
    onChange: handleOnChange,
    onBlur: handleOnBlur
  }), [className, orientation, t, values, getErrors, schema, handleOnChange, handleOnBlur]);
  return /*#__PURE__*/React.createElement(Multiplier, multiplierProps);
};
export default /*#__PURE__*/memo(AddForm);